import React from "react"
import ContentLayoutHeader from "../../../components/layouts/ContentLayoutHeader.layout"

const OccupationReportHeader = () => {
  return (
    <ContentLayoutHeader
      title="Reporte de facturación"
      buttonProps={{
        hidden: true,
      }}
    />
  )
}

export default OccupationReportHeader
